import type { RouteKey } from "@/core/constants";
import { EmptyState, PageHeader } from "@/core/ui/molecules";

import { getRouteByKey } from "./utils";

export function PlaceholderRoutePage({
  routeKey,
}: {
  readonly routeKey: RouteKey;
}) {
  const route = getRouteByKey(routeKey);

  return (
    <>
      <PageHeader
        breadcrumb={[route.label]}
        subtitle="This route is registered from the shared route constants."
        title={route.label}
      />
      <EmptyState
        description="The navigation and router are ready; this screen can now receive its business logic component when the feature is built."
        icon={<span className="text-base">+</span>}
        title={`${route.label} route ready`}
      />
    </>
  );
}
